import { alpha } from '@mui/material/styles';

import { colors } from '../../theme';
import { color, radius } from '../../theme/tokens';

// Radius comes from the token module rather than the 0.625rem (10px) these
// carried before — 10 is not one of the brief's locked three, and it matched
// neither the theme's button radius nor anything else in the tree.
export const buttonStyles = {
    primary: {
      height: '2.5rem',
      borderRadius: radius.md,
      textTransform: 'none',
      fontSize: '0.875rem',
      // Fill is set explicitly rather than left to the contained-primary
      // default: Login.js applies this to a Button with no `variant`, which
      // would otherwise render as a transparent text button.
      bgcolor: 'primary.main',
      color: 'primary.contrastText',
      boxShadow: theme => theme.customShadows.button,
      '&:hover': {
        bgcolor: 'primary.dark',
        boxShadow: theme => theme.customShadows.buttonHover,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.grey.border,
      }
    },
    secondary: {
      height: '2.5rem',
      borderRadius: radius.md,
      textTransform: 'none',
      borderColor: colors.grey.border,
      color: colors.green.medium,
      '&:hover': {
        borderColor: colors.green.medium,
        backgroundColor: colors.green.transparent.medium,
        boxShadow: theme => theme.customShadows.button,
      }
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    },
    auth: {
      mt: 2,
      mb: 2,
      height: '2.8125rem',
      minHeight: '2.8125rem',
      py: 1,
      px: '1.5rem',
      // Olive was this file's last off-palette fill; the `primary` variant
      // above already renders the brand green, so `auth` now matches it
      // instead of carrying its own.
      backgroundColor: 'primary.main',
      opacity: 0.9,
      color: 'primary.contrastText',
      borderRadius: radius.md,
      textTransform: 'none',
      fontSize: '0.9rem',
      fontWeight: 600,
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'primary.main',
        opacity: 1,
        transform: 'translateY(-0.0625rem)',
        boxShadow: `0 0.25rem 0.75rem ${alpha(color.evergreen, 0.2)}`
      },
      '&:active': {
        transform: 'translateY(0)',
      }
    },
    // `trial` — the iOS-blue "Start Free Trial" button — was deleted here
    // rather than recoloured. It had no consumer anywhere in `src/`, and it
    // was the only thing in this file carrying a px measurement. Surfaces that
    // want a trial CTA should reach for the theme's `variant="primary"`.
  };